// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"1112f113","242":"201048de","345":"eb0d0061","448":"0e2e6268","548":"e8249822","897":"ef2288c4"}[chunkId] + ".chunk.css";
};